<template>
  <div class="activitie-box">
    <div class="activitie-head"></div>
    <div class="activitie-main">
      <div class="activitie-explain">
        恭喜以下名单中的小伙伴获奖，我们会及时联系您，请注意保持电话畅通哦，所有的奖品将于2019年2月21日之后统一安排寄送，谢谢~~
      </div>
      <div class="activitie-one bgtagm">
        <div class="list-title">每日里程王中奖名单</div>
        <div class="list-tag">
          <template v-for="(item, key) in everydayMileageUsers">
            <template v-if="key < everydayMileageUsers.length">
              <van-row :key="key" class="list-row text-color">
                <van-col class="list-item" span="8">{{item.createAt.split(' ')[0]}}</van-col>
                <van-col class="list-item" span="8">{{item.nickname}}</van-col>
                <van-col class="list-item" span="8">{{item.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")}}</van-col>
              </van-row>
            </template>
          </template>
          <template v-if="everydayMileageUsers.length !== 0">
            <div style="height:20px;"></div>
            <div class="list-self">奖品：价值128元的机油一瓶</div>
          </template>
          <template v-if="everydayMileageUsers.length === 0">
            <van-row class="list-row text-color">
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
            </van-row>
          </template>
        </div>
      </div>
      <div class="activitie-one bgtagl">
        <div class="list-title">幸运里程奖中奖名单</div>
        <div class="list-tag">
          <template v-for="(item, key) in lucklyUsers">
            <template v-if="key < lucklyUsers.length">
              <van-row :key="key" class="list-row text-color">
                <van-col class="list-item" span="8">{{item.createAt}}</van-col>
                <van-col class="list-item" span="8">{{item.nickname}}</van-col>
                <van-col class="list-item" span="8">{{item.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")}}</van-col>
              </van-row>
            </template>
          </template>
          <template v-if="lucklyUsers.length === 0">
            <van-row class="list-row text-color">
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
            </van-row>
          </template>
          <div class="list-self" style="position:relative;">
            <div class="textline">奖品：</div>
            <div class="textline">总价值120元的SR Max300品牌T恤一件以及PIAGGIO品牌U盘一个</div>
            <div class="textline">总价值238元的aprilia品牌公仔一个及PIAGGIO品牌U盘一个</div>
            <div class="textline">总价值779元的PIAGGIO品牌骑行手套一双及ABUS碟刹防盗锁一把</div>
            <div>总价值1084元的aprilia品牌夹克一件及PIAGGIO品牌骑行手套一双</div>
            <div style="margin-top:20px;">*率先突破300km、800km、1500km、3000km得奖顺序以及奖品依排序对应</div>
          </div>
        </div>
      </div>

      <div class="activitie-one bgtags">
        <div class="list-title">智多星奖中奖名单</div>
        <div class="list-tag">
          <template v-for="(item, key) in mastermindMileageUsers">
            <van-row :key="key" class="list-row text-color">
              <van-col class="list-item" span="12">{{item.nickname}}</van-col>
              <van-col class="list-item" span="12">{{item.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")}}</van-col>
            </van-row>
          </template>
          <div style="height:20px;"></div>
          <div class="list-self">奖品：价值435元的ABUS碟刹防盗锁一把</div>
        </div>
      </div>
      <div class="activitie-one bgtagxs">
        <div class="list-title">SUPER STAR奖中奖名单</div>
        <div class="list-tag">
          <template v-for="(item, key) in superstarMileageUsers">
            <van-row :key="key" class="list-row text-color">
              <van-col class="list-item" span="12">{{item.nickname}}</van-col>
              <van-col class="list-item" span="12">{{item.phone.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")}}</van-col>
            </van-row>
          </template>
          <div style="height:20px;"></div>
          <div class="list-self">奖品：价值8880元的ZIP50一台</div>
        </div>
      </div>

      <div class="activitie-footer">
        <div class="activitie-tips">此次大赛的活动解释权归宗申•比亚乔佛山摩托车企业有限公司所有</div>
        <div class="activitie-logo"><img src="../../assets/images/logo.png"></div>
      </div>
    </div>
    <div class="activitie-foot"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Row, Col } from 'vant'
import { getActivitiesResult } from 'api/activities'
Vue.use(Row).use(Col)
export default {
  name: 'ActivitiesMatch',
  data () {
    return {
      tokenapi: '',
      everydayMileageUsers: [],
      lucklyUsers: [],
      totalMileageUsers: [],
      token: '',
      mastermindMileageUsers: [
        { 'nickname': '哈库呐玛塔塔', 'phone': '18637700163' },
        { 'nickname': '摩征885598', 'phone': '15874199757' },
        { 'nickname': 'Creator', 'phone': '15988345929' }
      ],
      superstarMileageUsers: [
        { 'nickname': '蓝小黑Zephyr', 'phone': '18611763666' }
      ]
    }
  },
  created () {
    this.token = window._native_.getToken()
    // this.getList()
  },
  watch: {
    token (newVal, oldVal) {
      this.getList()
    }
  },
  methods: {
    getList () {
      const KeyAip = this.token
      getActivitiesResult(KeyAip).then((res) => {
        console.log(res.data)
        const datas = res.data
        if (datas.error === '') {
          this.everydayMileageUsers = datas.data[0].everydayMileageUsers
          this.lucklyUsers = datas.data[0].lucklyUsers
          // this.totalMileageUsers = datas.data[0].totalMileageUsers
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@colorText:#d71835;
@colorTexttips:#423263;
@colorWhite:#ffffff;
@fontnomal:12px;
@fonttitle:15px;
.bgimg1s{
  background: url('../../assets/images/tag1m.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgimg2{
  background: url('../../assets/images/resulttag3.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgmain{
  background: url('../../assets/images/resultmain.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgmainnobor{
  background: url('../../assets/images/resultmainnobor.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgtitle{
  background: url('../../assets/images/resulttagtitle.png');
  background-size: 100% 100%;
  background-position: center;
}

.text-right{
  padding-left: 20px;
}
.text-color{
  color: @colorText !important;
}
html,body,#app{
  height: 100%;
  width: 100%;
}
.activitie{
  &-box{
    min-height: 100%;
    background: url('../../assets/images/resultbgnew.png');
    background-size: 100% 100%;
    background-position: center;
    font-family: '微软雅黑';
  }
  &-head{
    height: 210px;
    width: 100%;
    background: url('../../assets/images/result_title.png');
    background-size: 100% 100%;
    background-position: center;
  }
  &-foot{
    height: 55px;
    width: 100%;
  }
  &-main{
    .activitie{
      &-one{
        position: relative;
        margin-left: 23px;
        margin-right: 23px;
        margin-bottom: 45px;
        .list-tag{
          position: relative;
          min-height: 100px;
          padding: 36px 15px 20px 15px;
          border: 1px solid #95021c;
          border-radius: 8px;
          .bgmainnobor;
        }
        &.bgtagxs{
          .list-tag{
            min-height: 50px;
          }
        }
        &.bgtags{
          margin-bottom: 35px;
          .list-tag{
            min-height: 100px;
          }
        }
        &.bgtagm{
          .list-tag{
            min-height: 170px;
          }
          .text-right{
            padding-left: 0px;
          }
        }
        &.bgtagl{
          .list-tag{
            min-height: 200px;
          }
          .list-self{
            text-align: left;
            margin-bottom: 0px;
          }
        }
        .list-title{
          position: absolute;
          top: -30px;
          left: 0;
          width: 100%;
          height: 66px;
          line-height: 66px;
          font-size: @fonttitle;
          font-weight: bold;
          color: @colorText;
          text-align: center;
          .bgtitle;
          z-index: 2;
        }
        .list-row{
          font-size: @fontnomal;
          color: @colorWhite;
          .list-item{
            margin-bottom: 10px;
            &:last-child{
              margin-bottom: 0px;
            }
          }
        }
        .list-self{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          color: @colorTexttips;
          font-size: @fontnomal;
          margin-top:10px;
          margin-bottom: 15px;
          text-align: center;
          .textline{
            margin-bottom: 5px;
          }
        }
        .list-rule{
          font-size: @fontnomal;
          color: @colorText;
          line-height: 18px;
        }
      }
      &-explain{
        position: relative;
        .bgimg2;
        padding: 15px;
        margin: 0px 22px 40px 22px;
        color: @colorTexttips;
        font-size: @fontnomal;
      }
      &-footer{
        padding-top: 42px;
      }
      &-tips{
        width: 100%;
        font-size: 10px;;
        color: @colorWhite;
        text-align: center;
        -webkit-transform:scale(0.85);
      }
      &-logo{
        text-align: center;
        margin-top: 10px;
        img{
          height: 26px;
          width: auto;
        }
      }
    }
  }
}
</style>
